import styled, { css } from 'styled-components';

export const Root = styled.div`
  ${({ theme, $isMobile }) => css`
    background: ${theme.v3.colors.neutral[100]};
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: fit-content;
    box-sizing: border-box;
    ${$isMobile
    ? css`
          border-top-left-radius: ${theme.v3.border.radius.md};
          border-top-right-radius: ${theme.v3.border.radius.md};
          padding: 28px 0;
        `
    : css`
          border-radius: ${theme.v3.border.radius.md};
          padding: ${theme.v3.spacing.md} ${theme.v3.spacing.md} ${theme.v3.spacing['2xl']};
          gap: ${theme.v3.spacing['2xl']};
        `}
  `}
`;

export const BrandRow = styled.div`
  ${({ theme, $isMobile }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
    margin-bottom: ${$isMobile ? theme.v3.spacing.xs : theme.v3.spacing.xxs};
  `}
`;

export const ShieldWrap = styled.div`
  ${({ $isMobile }) => css`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    ${$isMobile
    ? css`
          width: 36px;
          height: 40px;
        `
    : css`
          width: 59px;
          height: 65px;
        `}

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  `}
`;

export const BrandTextCol = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  `}
`;

export const ProductTitle = styled.span`
  ${({ theme, $isMobile }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    font-size: ${$isMobile ? theme.v3.font.sizes['1xlarge'] : theme.v3.font.sizes.huge};
    font-weight: ${theme.v3.font.weights.medium};
  `}
`;

export const ProductSubtitle = styled.span`
  ${({ theme, $isMobile }) => css`
    background: linear-gradient(
      171deg,
      ${theme.v3.colors.brand.snappyBlue[10]} 14.84%,
      ${theme.v3.colors.brand.snappyBlue[40]} 85.61%
    );
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-size: ${$isMobile ? theme.v3.font.sizes.min : theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    padding-left: 2px;
  `}
`;

export const MessageBlock = styled.div`
  ${({ theme, $isMobile }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.nano};
    align-items: center;
    text-align: center;
    width: 100%;
    max-width: 100%;
    margin-bottom: ${$isMobile ? theme.v3.spacing.xxs : theme.v3.spacing.md};
  `}
`;

export const Headline = styled.h2`
  ${({ theme, $isMobile }) => css`
    margin: 0;
    color: ${theme.v3.colors.brand.snappyBlue[5]};
    font-size: ${$isMobile ? theme.v3.font.sizes['1xlarge'] : theme.v3.font.sizes.huge};
    font-weight: ${theme.v3.font.weights.medium};
    width: 100%;
  `}
`;

export const BodyText = styled.p`
  ${({ theme, $isMobile }) => css`
    margin: 0;
    font-family: ${theme.v3.font.family.brand};
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${$isMobile ? theme.v3.font.sizes['1xmedium'] : theme.v3.font.sizes['1xlarge']};
    font-weight: ${theme.v3.font.weights.regular};
    width: 100%;
    max-width: ${$isMobile ? '100%' : '582px'};

    strong {
      font-weight: ${theme.v3.font.weights.bold};
    }
  `}
`;

export const PrimaryButtonWrap = styled.div`
  ${() => css`
    width: 100%;
    display: flex;
    justify-content: center;
  `}
`;
